import React, {useState} from 'react';
import {Button, Modal, Select} from "antd";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";

const RoleModal = (props) => {
    const [sendData, setSendData] = useState("")

    const sendAll = () => {
        axios.post(API_PATH  + "company/"+localStorage.getItem('id') + "/role/create", {name: sendData},  {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                toast.success("Добавлено успешно")
                props.setIsLocModal(false)
                props.getRoles()
            })
    }


    return (
        <Modal title="Добавить"
               open={props.isLocModal}
               onCancel={() => props.setIsLocModal(false)}
               footer={[
                   <Button key="submit" type="primary" onClick={sendAll}>
                       Добавить
                   </Button>,
                   <Button key="submit" type="default" onClick={() => props.setIsLocModal(false)}>
                       Отменить
                   </Button>
               ]}
        >
            <div className="cam-add-modal">
                <div className="inputs-box">
                    <label className="font-family-medium">Название</label>
                    <input onChange={(e) => setSendData(  e.target.value)} type="text"/>
                </div>
            </div>
        </Modal>
    );
};

export default RoleModal;